import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "back-button",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('goBack')), ["prevent","stop"]))
  }, [
    _renderSlot(_ctx.$slots, "label", {}, () => [
      _createTextVNode(" Back ")
    ])
  ]))
}